/**
 * @voltxampere/shared — Error category abstracts
 *
 * One abstract class per SPECS §5.2 category. Each fixes the
 * `category` literal and leaves `code` / `recoverable` /
 * `defaultSeverity()` to the leaf. Consumers that want to catch
 * "any storage error" can do `catch (e) { if (e instanceof
 * StorageError) ... }`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { VXAError } from "./base.js";
export class UserError extends VXAError {
    category = "user";
}
export class EngineError extends VXAError {
    category = "engine";
}
export class StorageError extends VXAError {
    category = "storage";
}
export class PluginError extends VXAError {
    category = "plugin";
}
export class SystemError extends VXAError {
    category = "system";
}
//# sourceMappingURL=categories.js.map